export class Inspection {
id = '';
equipment_Id = '';
engineer_Id = '';
location_Id = '';
job_Id = '';
missing: boolean = false;
inspected_At = '';
submitted_At = '';
safe_For_Use: boolean = false;
next_Inspection_Date = '';
purpose_Of_Examination_Id:number = 0;
first_Examination: boolean = false;
installed_Correctly: boolean = false;
immediate_To_Persons: boolean = false;
danger_To_Persons = '';
become_Danger_To_Persons: boolean = false;
repair = '';
repair_Date = '';
observations = '';
userId='';


















is_edit: boolean = false;
}
